import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { useCallback, useContext, useState } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import ReportCardBody from './ReportCardBody';
import ReportCardHeader from './ReportCardHeader';
import { ADD_ONS, DISPLAY_MODES, WRAPPER_USE } from './constants/ReportCardOptions';
import { isCopilotEnabled } from './utils/addons';
// @ts-expect-error migrate upstream files
import ReportDeprecationAlert from 'reporting-ui-components/components/PlatformReport/ReportDeprecationAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReportCardInternal({
  report,
  appUsageTracker,
  header,
  subheader,
  footer,
  description,
  alert,
  reportActions = [],
  additionalReportActions = [],
  addOns = [],
  onReportResolve: customOnReportResolve,
  onError,
  setIsReportViewerIsOpen,
  setPreviewReport,
  isReportActionsDisabled,
  errorRenderer,
  blockSize,
  minBlockSize,
  enableReportResolveUsageTracking,
  onClickViewSRVAction,
  noDataRenderer,
  use = WRAPPER_USE.CARD,
  ToolbarOverride,
  isReportRemixChange,
  displayMode
}) {
  const userInfo = useContext(UserInfoContext);
  const [reportResolve, setReportResolve] = useState();
  const copilotEnabled = isCopilotEnabled(userInfo.gates, addOns);
  const onReportResolve = useCallback(props => {
    if (customOnReportResolve) {
      customOnReportResolve(props);
    }
    setReportResolve(props);
  }, [customOnReportResolve]);
  const body = /*#__PURE__*/_jsx(ReportCardBody, {
    addOns: addOns,
    report: report,
    appUsageTracker: appUsageTracker,
    onReportResolve: onReportResolve,
    onError: onError,
    setPreviewReport: setPreviewReport,
    errorRenderer: errorRenderer,
    enableReportResolveUsageTracking: enableReportResolveUsageTracking,
    noDataRenderer: noDataRenderer,
    ToolbarOverride: ToolbarOverride,
    isReportRemixChange: isReportRemixChange
  });
  if (addOns.includes(ADD_ONS.DISABLE_CARD_WRAPPER)) return body;
  const WrapperComponent = use === WRAPPER_USE.TILE ? Tile : CardWrapper;
  return /*#__PURE__*/_jsxs(WrapperComponent, {
    "data-test-id": "report-card-v2--card-wrapper",
    blockSize: blockSize,
    minBlockSize: minBlockSize,
    compact: true,
    padding: addOns.includes(ADD_ONS.COMPACT_CARD) ? '300' : '500',
    margin: addOns.includes(ADD_ONS.COMPACT_CARD) ? '0' : undefined,
    display: "flex",
    flexDirection: "column",
    borderStyle: displayMode === DISPLAY_MODES.DASHBOARD ? 'none' : undefined,
    children: [(header || ToolbarOverride || addOns.includes(ADD_ONS.VIEW_SRV) || copilotEnabled || reportActions.length > 0 || additionalReportActions.length > 0) && /*#__PURE__*/_jsx(ReportCardHeader, {
      header: header,
      subheader: subheader,
      description: description,
      reportActions: reportActions,
      additionalReportActions: additionalReportActions,
      appUsageTracker: appUsageTracker,
      report: report,
      reportResolve: reportResolve,
      setIsReportViewerIsOpen: setIsReportViewerIsOpen,
      addOns: addOns,
      isReportActionsDisabled: isReportActionsDisabled,
      onClickViewSRVAction: onClickViewSRVAction,
      ToolbarOverride: ToolbarOverride
    }), subheader, /*#__PURE__*/_jsx(ReportDeprecationAlert, {
      report: report,
      marginStart: "100"
    }), alert, body, footer]
  });
}